module.exports = __webpack_public_path__ + "assets/posthog.883ab8b3.svg";